import React, { FC, ReactNode } from 'react';

import MainLayoutSidebarDesktop from '~/components/layouts/MainLayout/components/MainLayoutSidebar/Desktop';
import { SideBarItemType } from '~/core/sidebar';

import styles from './styles.module.scss';

type Props = {
  sidebarGroups: SideBarItemType[][];
  children?: React.ReactNode;
  sidebar?: ReactNode;
};

const DesktopSidebar: FC<Props> = ({ sidebarGroups, children, sidebar }) => {
  return (
    <div className={styles.layout}>
      <div className={styles.layout__sidebar}>
        {sidebar ?? <MainLayoutSidebarDesktop items={sidebarGroups} />}
      </div>

      <div className={styles.layout__content}>{children}</div>
    </div>
  );
};

export default DesktopSidebar;
